module.exports = __webpack_public_path__ + "static/img/curostain.c769bd2d.jpg";